// Add your custom JS here.
( function( $ ) {



    Calendly.initInlineWidget({
        url: 'https://calendly.com/barnesdemo/barnestech',
        parentElement: document.getElementById('boeken'),
        prefill: {},
        utm: {}
    });

    
    // home fold words & video toggle
    if ($("body").hasClass("page-template-frontpage")) {
        var authors = $('#typewriter .word').map(function() {
            return this.innerText;
        }).get();
    
        const typewriter = document.querySelector("#typewriter");
        tinyTypewriter(typewriter, {
            items: authors
        });

        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
            $(window).scrollTop($(window).scrollTop()+1);
        }



        const iframe = document.querySelector('#vimeoplayer');
        const player = new Vimeo.Player(iframe);

        // video toggle
        $(".video").on("click", function () {
            $(".video-popup").addClass('active');
            player.play();
        });

        $(".video-popup").on("click", function () {
            $(".video-popup").removeClass('active');
            player.pause();
        });
    }


    



    	
    $(function () {
        $(".logos").gridrotator({
          rows: 1,
          columns: 6,
    
          w1024: {
            rows: 3,
            columns: 4,
          },
    
          w768: {
            rows: 1,
            columns: 4,
          },
    
          w480: {
            rows: 2,
            columns: 3,
          },
    
          w320: {
            rows: 2,
            columns: 3,
          },
    
          w240: {
            rows: 2,
            columns: 3,
          },

          w0: {
            rows: 2,
            colums: 3,
          },
    
          step: 2,
          maxStep: 3,
    
          preventClick: false,
    
          animType: "fadeInOut",
    
          // animation speed
          animSpeed: 500,
    
          // animation easings
          animEasingOut: "linear",
          animEasingIn: "linear",
    
          interval: 1000,
          slideshow: true,
          onhover: false,
          nochange: [],
        });
      });
    
		




    // Fade in effects
    AOS.init();


    // number counters
    new Counter('.counter');
       

    var image = document.getElementsByClassName('parallaximg-1');
    new simpleParallax(image, {
        overflow: true,
        scale: 1.8
    });

    var image = document.getElementsByClassName('parallaximg-2');
    new simpleParallax(image, {
        overflow: true,
        scale: 1.9
    });

    var image = document.getElementsByClassName('parallaximg-4');
    new simpleParallax(image, {
        overflow: true,
        scale: 1.7
    });

    var image = document.getElementsByClassName('parallaximg-6');
    new simpleParallax(image, {
        overflow: true,
        scale: 1.6
    });

    var image = document.getElementsByClassName('parallaximg-8');
    new simpleParallax(image, {
        overflow: true,
        scale: 1.75
    });

    var image = document.getElementsByClassName('parallaximg-10');
    new simpleParallax(image, {
        overflow: true,
        scale: 1.85
    });

    var image = document.getElementsByClassName('parallaximg-12');
    new simpleParallax(image, {
        overflow: true,
        scale: 1.65
    });

    var image = document.getElementsByClassName('parallaximg-14');
    new simpleParallax(image, {
        overflow: true,
        scale: 1.8
    });
    


    // Smooth anchor scrolling
    var scroll = new SmoothScroll('a[href*="#"]', {
        speed: 300
    });

    if ( $( "#textpath" ).length ) {
 
        const textPath = document.querySelector("#textpath");
        const h = document.documentElement, 
            b = document.body,
            st = 'scrollTop',
            sh = 'scrollHeight';

        var vwwidth = $(document).width();
        document.addEventListener("scroll", e => {
            let percent = (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100;
            textPath.setAttribute("startOffset", (-percent * 40));
        });
     
    }



    // check if page is scrolled from the top for header
    $(document).scroll(function(){
        if($(this).scrollTop() > 50)
        {   
            $('#wrapper-navbar').addClass('off-top');

        }
        if($(this).scrollTop() < 50)
        {   
            $('#wrapper-navbar').removeClass('off-top');
        }
    });



    // show header based on scroll directions
    var lastScrollTop = 0;
    $(window).scroll(function(event){
        var st = $(this).scrollTop();
        if (st > lastScrollTop){
            $('#wrapper-navbar').addClass('hide');
        } else {
            $('#wrapper-navbar').removeClass('hide');
        }
        lastScrollTop = st;
    });


    
    // Words swiper
    var wordSwiper = new Swiper(".words-swiper", {
        slidesPerView: 1,
        center: true,
        direction: "vertical",
        loop: true,
        autoplay: true,
    });



    // Reviews swiper
    var wordSwiper = new Swiper(".review-swiper", {
        slidesPerView: 1,
        center: true,
        loop: true,
        autoplay: true,
        pagination: {
            clickable: true,
            el: '.review-pagination',
            type: 'bullets',
        },
    });



    // Team swiper 
    var wordSwiper = new Swiper(".team-swiper", {
        slidesPerView: "auto",
        center: true,
        spaceBetween: 20,
        loop: false,
        autoplay: false,
        pagination: {
            clickable: true,
            el: '.team-pagination',
            type: 'bullets',
        },
    });





    // Stories swiper
    var storiesSwiper = new Swiper(".stories-swiper", {
        slidesPerView: "auto",
        center: false,
        loop: false,
        spaceBetween: 40,
        autoplay: false,
        pagination: {
            el: '.stories-pagination',
            type: 'progressbar',
        },
    });




    // faq functionalities
    $(".faq-cat:nth-child(1), #faq-1, .faq-image-1").addClass('active');

    $(".faq-cat").on("click", function () {

        var faqId = $(this).attr("data-faqid");
        $(".faq-cat").removeClass('active');
        $(this).addClass('active');

        $(".faq.active").fadeOut(500, function(){
            $("#faq-" + faqId + "").fadeIn(500);
            $(".faq.active").removeClass('active');
            $("#faq-" + faqId + "").addClass("active");
        });

        $(".faq-image.active").fadeOut(500, function(){
            $(".faq-image-" + faqId + "").fadeIn(500);
            $(".faq-image.active").removeClass('active');
            $(".faq-image-" + faqId + "").addClass("active");
        });
    });

    $(".faq li").on("click", function () {

        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).children(".a").slideUp();

        } else {
            $(".a").slideUp();
            $(".faq li").removeClass('active');
            $(this).addClass('active');
            $(this).children(".a").slideDown();
        }
    });


    // menu toggle
    $(".header-toggle").on("click", function () {
        $("#wrapper-navbar .menu").toggleClass('active');
        $(this).toggleClass('active');
        $("#wrapper-navbar").toggleClass('active');
    });



    // booking toggle
    $(".book").on("click", function () {
        $("#boeken").addClass('active');
    });

    $("#boeken").on("click", function () {
        $(this).removeClass('active');
    });



    // professionals horizontal section
    if($('.steps').length){
        
        gsap.registerPlugin(ScrollTrigger);

        let sections = gsap.utils.toArray(".step");

        if ($(window).width() <= 992) {
            gsap.to(sections, {
                xPercent: -100 * (sections.length - 0.5),
                ease: "none",
                scrollTrigger: {
                    trigger: ".section-three",
                    pin: true,
                    scrub: 1,
                    end: () =>
                        "+=" +
                        document.querySelector(".steps").offsetWidth,
                },
            });
        } else {
            gsap.to(sections, {
                xPercent: -100 * (sections.length - 1.5),
                ease: "none",
                scrollTrigger: {
                    trigger: ".section-three",
                    pin: true,
                    scrub: 1,
                    end: () =>
                        "+=" +
                        document.querySelector(".steps").offsetWidth,
                },
            });
        }
    }



    // filter functions
    $('.mobile-filter').on('click', function() {
		$('.sidebar').addClass('active');
		$('.mobile-show-results-button').addClass('active');
    });

	$('.mobile-close-cross, .mobile-show-results-button').on('click', function() {
		$('.sidebar').removeClass('active');
		$('.mobile-show-results-button').removeClass('active');
    });

	$('#textinput-searchbutton').on('click', function() {
		$('.sidebar').removeClass('active');
		$('.mobile-show-results-button').removeClass('active');
    });

	$('#textinput-searchfield').keypress(function (event) {
		if (event.keyCode === 10 || event.keyCode === 13) {
			event.preventDefault();
			$("#textinput-searchfield").blur(); 
		}
	});

	$('#textinput-searchbutton').on('click', function() {
		$("#textinput-searchfield").blur(); 
    });


    if ( $( "#particles-js-one" ).length ) {

        // particles config
        particlesJS("particles-js-one", {
            "particles": {
                "number": {
                    "value": 80,
                    "density": {
                        "enable": true,
                        "value_area": 800
                    }
                },
                "color": {
                    "value": "#ffffff"
                },
                "shape": {
                    "type": "circle",
                    "stroke": {
                        "width": 0,
                        "color": "#ffffff"
                    },
                    "polygon": {
                        "nb_sides": 5
                    }
                },
                "opacity": {
                    "value": 0.1,
                    "random": false,
                    "anim": {
                        "enable": false,
                        "speed": 1,
                        "opacity_min": 0.1,
                        "sync": false
                    }
                },
                "size": {
                    "value": 7,
                    "random": true,
                    "anim": {
                        "enable": false,
                        "speed": 40,
                        "size_min": 0.7,
                        "sync": false
                    }
                },
                "line_linked": {
                    "enable": true,
                    "distance": 150,
                    "color": "#ffffff",
                    "opacity": 0.2,
                    "width": 2
                },
                "move": {
                    "enable": true,
                    "speed": 2,
                    "direction": "none",
                    "random": false,
                    "straight": false,
                    "out_mode": "out",
                    "bounce": false,
                    "attract": {
                        "enable": false,
                        "rotateX": 600,
                        "rotateY": 1200
                    }
                }
            },
            "interactivity": {
                "detect_on": "canvas",
                "events": {
                    "onhover": {
                        "enable": false,
                        "mode": "grab"
                    },
                    "onclick": {
                        "enable": false,
                        "mode": "push"
                    },
                    "resize": true
                },
                "modes": {
                    // "push": {
                    //     "particles_nb": 4
                    // },
                    // "remove": {
                    //     "particles_nb": 2
                    // }
                }
            },
            "retina_detect": true
        });
    }


    if ( $( "#particles-js-two" ).length ) {

        // particles config
        particlesJS("particles-js-two", {
            "particles": {
                "number": {
                    "value": 80,
                    "density": {
                        "enable": true,
                        "value_area": 800
                    }
                },
                "color": {
                    "value": "#ffffff"
                },
                "shape": {
                    "type": "circle",
                    "stroke": {
                        "width": 0,
                        "color": "#ffffff"
                    },
                    "polygon": {
                        "nb_sides": 5
                    }
                },
                "opacity": {
                    "value": 0.1,
                    "random": false,
                    "anim": {
                        "enable": false,
                        "speed": 1,
                        "opacity_min": 0.1,
                        "sync": false
                    }
                },
                "size": {
                    "value": 7,
                    "random": true,
                    "anim": {
                        "enable": false,
                        "speed": 40,
                        "size_min": 0.7,
                        "sync": false
                    }
                },
                "line_linked": {
                    "enable": true,
                    "distance": 150,
                    "color": "#ffffff",
                    "opacity": 0.2,
                    "width": 2
                },
                "move": {
                    "enable": true,
                    "speed": 2,
                    "direction": "none",
                    "random": false,
                    "straight": false,
                    "out_mode": "out",
                    "bounce": false,
                    "attract": {
                        "enable": false,
                        "rotateX": 600,
                        "rotateY": 1200
                    }
                }
            },
            "interactivity": {
                "detect_on": "canvas",
                "events": {
                    "onhover": {
                        "enable": true,
                        "mode": "grab"
                    },
                    "onclick": {
                        "enable": true,
                        "mode": "push"
                    },
                    "resize": true
                },
                "modes": {
                    "push": {
                        "particles_nb": 4
                    },
                    "remove": {
                        "particles_nb": 2
                    }
                }
            },
            "retina_detect": true
        });
    }



    if ( $( "#particles-js-footer" ).length ) {

        // particles config
        particlesJS("particles-js-footer", {
            "particles": {
                "number": {
                    "value": 80,
                    "density": {
                        "enable": true,
                        "value_area": 800
                    }
                },
                "color": {
                    "value": "#ffffff"
                },
                "shape": {
                    "type": "circle",
                    "stroke": {
                        "width": 0,
                        "color": "#ffffff"
                    },
                    "polygon": {
                        "nb_sides": 5
                    }
                },
                "opacity": {
                    "value": 0.1,
                    "random": false,
                    "anim": {
                        "enable": false,
                        "speed": 1,
                        "opacity_min": 0.1,
                        "sync": false
                    }
                },
                "size": {
                    "value": 7,
                    "random": true,
                    "anim": {
                        "enable": false,
                        "speed": 40,
                        "size_min": 0.7,
                        "sync": false
                    }
                },
                "line_linked": {
                    "enable": true,
                    "distance": 150,
                    "color": "#ffffff",
                    "opacity": 0.2,
                    "width": 2
                },
                "move": {
                    "enable": true,
                    "speed": 2,
                    "direction": "none",
                    "random": false,
                    "straight": false,
                    "out_mode": "out",
                    "bounce": false,
                    "attract": {
                        "enable": false,
                        "rotateX": 600,
                        "rotateY": 1200
                    }
                }
            },
            "interactivity": {
                "detect_on": "canvas",
                "events": {
                    "onhover": {
                        "enable": true,
                        "mode": "grab"
                    },
                    "onclick": {
                        "enable": true,
                        "mode": "push"
                    },
                    "resize": true
                },
                "modes": {
                    "push": {
                        "particles_nb": 4
                    },
                    "remove": {
                        "particles_nb": 2
                    }
                }
            },
            "retina_detect": true
        });
    }
      
} )( jQuery );